export default __webpack_public_path__ + "static/media/icon_cloudDocument.dc82b130.png";